export default "__VITE_ASSET__ffcfc444__"